import Cookies from 'js-cookie'
import { ProcessingResult } from '../ProcessingResult'

export const StereoToSpatialCookie = {
  FileName: 'sts_file',
  IasUrl: 'sts_ias',
  IasSpatializedId: 'sts_spatialized_ias_id',
  JobId: 'sts_job_id',
  ProcessingIsoDate: 'sts_date',
}

export class StereoToSpatialResult extends ProcessingResult {
  iasSpatializedId: string | undefined

  constructor(data?: {
    iasSpatializedId: string | undefined
    fileName?: string
    iasUrl?: string
    jobId?: string
    processingIsoDate?: string
    userId?: string
  }) {
    super({
      fileName: data?.fileName,
      iasUrl: data?.iasUrl,
      jobId: data?.jobId,
      processingIsoDate: data?.processingIsoDate,
      userId: data?.userId,
    })

    this.iasSpatializedId = data?.iasSpatializedId
  }

  isComplete() {
    return undefined != this.iasSpatializedId
  }

  getSavedJobId() {
    return Cookies.get(StereoToSpatialCookie.JobId)
  }

  isResultDownloadAvailable() {
    return undefined != this.iasSpatializedId
  }

  save() {
    super.save()
    super.setOrRemoveCookie(StereoToSpatialCookie.FileName, this.fileName)
    super.setOrRemoveCookie(StereoToSpatialCookie.IasUrl, this.iasUrl)
    super.setOrRemoveCookie(StereoToSpatialCookie.JobId, this.jobId)
    super.setOrRemoveCookie(
      StereoToSpatialCookie.ProcessingIsoDate,
      this.processingIsoDate
    )
    super.setOrRemoveCookie(StereoToSpatialCookie.IasSpatializedId,
      this.iasSpatializedId)
  }

  load() {
    super.load()
    this.fileName = Cookies.get(StereoToSpatialCookie.FileName)
    this.iasUrl = Cookies.get(StereoToSpatialCookie.IasUrl)
    this.jobId = Cookies.get(StereoToSpatialCookie.JobId)
    this.processingIsoDate = Cookies.get(
      StereoToSpatialCookie.ProcessingIsoDate
    )
    this.iasSpatializedId = Cookies.get(StereoToSpatialCookie.IasSpatializedId)
  }

  static cleanSavedData() {
    super.cleanSavedData()
    Cookies.remove(StereoToSpatialCookie.FileName)
    Cookies.remove(StereoToSpatialCookie.IasUrl)
    Cookies.remove(StereoToSpatialCookie.JobId)
    Cookies.remove(StereoToSpatialCookie.ProcessingIsoDate)
    Cookies.remove(StereoToSpatialCookie.IasSpatializedId)
  }

  setDebugData() {
    super.setDebugData()
  }
}
